import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, map } from 'rxjs';
import {
  PhoneDirectoryListResponse,
  PhoneDirectoryPage,
  PhoneDirectoryQuery,
} from './phone-directory.models';

@Injectable({ providedIn: 'root' })
export class PhoneDirectoryService {
  private readonly http = inject(HttpClient);

  search(query: PhoneDirectoryQuery): Observable<PhoneDirectoryPage> {
    let params = new HttpParams()
      .set('pageNumber', String(query.pageNumber))
      .set('pageSize', String(query.pageSize));

    const keyword = query.keyword.trim();
    if (keyword.length >= 2) {
      params = params.set('keyword', keyword);
    }
    if (query.source !== 'all') {
      params = params.set('source', query.source);
    }

    return this.http
      .get<PhoneDirectoryListResponse>(`${environment.apiUrl}phone-directory`, { params })
      .pipe(
        map((resp) => ({
          items: resp?.data ?? [],
          totalRecords: resp?.meta?.totalRecords ?? 0,
        }))
      );
  }
}
